import { RadioButtonProps } from './RadioButton.types';
import {
  SortDownIcon,
  SortUpIcon,
  RadioContainer,
  Input,
  Label,
} from './RadioButton.styled';

export const RadioButton = ({
  value,
  label,
  checked,
  cb,
}: RadioButtonProps) => {
  const radioContainerClick = () => {
    cb(value);
  };
  return (
    <RadioContainer onClick={radioContainerClick}>
      <Label htmlFor="sortOption">{label}</Label>
      {value.split(':')[1] === 'asc' ? <SortUpIcon /> : <SortDownIcon />}
      <Input
        type="radio"
        value={value}
        checked={checked}
        onChange={() => cb(value)}
      />
    </RadioContainer>
  );
};
